import React from 'react';
import { useReportOptions } from '../../hooks/useReportOptions.js';
import { useSelector } from 'react-redux';
import Select from '../../../common/Select';
import { useSetWidgetAttribute } from '../../hooks/useSetWidgetAttribute.js';
import { Row, Col } from '../../../bootstrap';
import ColorPicker from '../../../common/ColorPicker/DashboardColorPicker.jsx';
import CollapsibleSection from '../../../common/CollapsibleSection.jsx';
import WidgetTitleSettings from '../../settings_sidebar/WidgetTitleSettings.jsx';
import { MIN_FONT, MAX_FONT, IMAGE_DEFAULT_FONT, VALUE_DEFAULT_FONT, NAME_ITEM_DEFAULT_FONT } from '../../settings_sidebar/chart/ChartSettings.jsx';
import commonStyles from '../base/CommonSettings.module.scss';
import CommonSlider from '../../../common/CommonSlider.jsx';

function WorkflowDatastripBeforeDatasetSettings({ widgetId }) {
    const setAttribute = useSetWidgetAttribute(widgetId);
    const { data: workflowOptions } = useReportOptions();
    const workflow_ids = useSelector(state => state.dashboard.widgets[widgetId].settings?.workflow_ids);
    const all_submissions = useSelector(state => state.dashboard.widgets[widgetId].settings?.all_submissions);
    const own_projects = useSelector(state => state.dashboard.widgets[widgetId].settings?.own_projects);    
    const assigned_workflows = useSelector(state => state.dashboard.widgets[widgetId].settings?.assigned_workflows);
    const legend_text_color = useSelector(state => state.dashboard.widgets[widgetId].settings?.legend_text_color);
    const imageFontSize = useSelector(state => state.dashboard.widgets[widgetId].settings?.image_fontSize);
    const valueFontSize = useSelector(state => state.dashboard.widgets[widgetId].settings?.value_fontSize);
    const nameItemFontSize = useSelector(state => state.dashboard.widgets[widgetId].settings?.name_item_fontSize);
    const stacking = useSelector(state => state.dashboard.widgets[widgetId].settings?.stacking);

    return (
        <>
            <hr></hr>
            <CollapsibleSection title={I18n.t('content_settings')}>
            <WidgetTitleSettings widgetId={widgetId} />
            <div className={commonStyles['settings-option']}>
                <label>{I18n.t('legend_text_color_title')}
                <ColorPicker                
                    value={legend_text_color} 
                    onChange={(val) => setAttribute("settings.legend_text_color", val)}
                />
                </label>
            </div>
            <fieldset>
                <label className="w-100">
                {I18n.t("monitoring_reports")}
                <p className='font-weight-normal'>{I18n.t('workflow_datastrip_widget_sub_description')}</p>
                <Select
                    value={workflow_ids}
                    options={(workflowOptions || []).map(v => ({value: v.id, label: v.name}))} 
                    isMulti = {true}
                    selectionsLimit={3}
                    onChange={(v) => setAttribute("settings.workflow_ids", v)}
                />
                </label>
            </fieldset>
            <fieldset>
                <label>{I18n.t("projects_scope_conf")}</label>
                <Row>
                <Col size={`xs-12 sm-4`}>
                    <input
                    type="checkbox" 
                    name="all_submissions" 
                    checked={all_submissions} 
                    onChange={e => setAttribute('settings.all_submissions', e.target.checked)} 
                    />
                    <label htmlFor="all_submissions">{I18n.t('all_submissions')}</label>
                </Col>
                <Col size={`xs-12 sm-4`}>
                    <input
                    type="checkbox" 
                    name="own_projects" 
                    checked={own_projects} 
                    onChange={e => setAttribute('settings.own_projects', e.target.checked)} 
                    />
                    <label htmlFor="own_projects" >{I18n.t('own_projects')}</label>
                </Col>
                <Col size={`xs-12 sm-4`}>
                    <input
                    type="checkbox" 
                    name="assigned_workflows" 
                    checked={assigned_workflows} 
                    onChange={e => setAttribute('settings.assigned_workflows', e.target.checked)} 
                    />
                    <label htmlFor="assigned_workflows">{I18n.t('assigned_workflows')}</label>
                </Col>
                </Row>
            </fieldset>
            <div className={commonStyles['settings-option']}>
                <label className={commonStyles['settings-option']} style={{marginBottom: '4px'}}>
                    {I18n.t('stacking_direction')}
                    <Select
                        options={[{label: I18n.t('vertical'), value: 'vertical'}, {label: I18n.t('horizontal'), value: 'horizontal'}]}
                        value={stacking || 'horizontal'}
                        placeholder={I18n.t('select_from_list')}
                        onChange={(v) => setAttribute('settings.stacking', v)}
                    />
                </label>
            </div>
            <div className={commonStyles['settings-option']}>
                <label>{`${I18n.t('image')} ${I18n.t('normalize_font_size')}`}</label>
                <CommonSlider 
                    value={imageFontSize || IMAGE_DEFAULT_FONT} 
                    min={MIN_FONT} 
                    max={MAX_FONT+100} 
                    onChange={(value) => setAttribute('settings.image_fontSize', value)}
                />
            </div>
            <div className={commonStyles['settings-option']}>
                <label>{`${I18n.t('value')} ${I18n.t('normalize_font_size')}`}</label>
                <CommonSlider 
                    value={valueFontSize || VALUE_DEFAULT_FONT} 
                    min={MIN_FONT} 
                    max={MAX_FONT} 
                    onChange={(value) => setAttribute('settings.value_fontSize', value)}
                />
            </div>
            <div className={commonStyles['settings-option']}>
                <label>{`${I18n.t('name_item')} ${I18n.t('normalize_font_size')}`}</label>
                <CommonSlider 
                    value={nameItemFontSize || NAME_ITEM_DEFAULT_FONT} 
                    min={MIN_FONT} 
                    max={MAX_FONT} 
                    onChange={(value) => setAttribute('settings.name_item_fontSize', value)}
                />
            </div>
            </CollapsibleSection>
        </>
    )
}

export default WorkflowDatastripBeforeDatasetSettings;
